import React, { Component } from 'react';
import CollectionBrowser from "./../../components/collectionBrowser";
import TextAndImage from "./../../alpineComponents/textAndImage";
import BlogPostThumb from "./../../components/blogPostThumb";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import PublicSpeakingTeaser from "./../../components/publicSpeakingTeaser";
import BannerFadeIn from "./../../components/bannerFadeIn";
import Flodeskform from "./../../components/flodeskForm";
import FullWidthPortfolioTeaser from "./../../components/fullWidthPortfolioTeaser";
import {BlogPosts} from "./../../utils/blog";
import { withController, Parallax } from 'react-scroll-parallax';
import Footer from './../../components/footer';
import {PrimaryBookLink, PrimaryReviewLink,BookstoreBookLink} from "./../../utils/constants";
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";
import HomeSlider from './../../components/homeSlider/homeSlider';
import BookList from './../../components/bookList';

class Home extends Component {
  render() {
    //Writer, Entrepreneur, Adventurer & Joy Finder
    return (
      <div className="full-height full-width">
        <Helmet>
          <title>{'Kat Medina | Author of the book, The Joys of Jet Lag'}</title>
          <meta name="description" content="Kat Medina is an author, traveler, entrepreneur, and joy finder. The book, The Joys of Jet Lag, guides readers on a journey to discover the keys to cultivating a life of unbridled joy and fulfillment through an openhearted approach to purposeful living. Written by Kat (Kathryn) Medina." />
        </Helmet>
        <BannerFadeIn>
          <HomeSlider />
        </BannerFadeIn>
        <BookList />

        <ScrollFadeIn>
          <PublicSpeakingTeaser />
        </ScrollFadeIn>
        <ScrollFadeIn>
          <div className="medium-padding">
            <div className="max-width-container">
              <img src={"/images/press-hero.jpg"} className="full-width" />
              <div className="small-max-width-container lip">
                <div className="primary-background white small-padding centered-text">
                  <h4>{'As a child, I wanted to be MacGyver when I grew up.'}</h4>
                  <p>{`Now, as an author and public speaker, I've become a well-traveled bookworm who teaches people how to discover more joy in daily life with the resourcefulness of a figurative shoelace, paperclip, and bubblegum. Not quite the MacGyver I had in mind, but at least this way I don't have to rock a mullet (although I, unfortunately, did so as a kid).`}</p>  
                  <Link to={'/about'}>
                    <div className="small-padding" style={{paddingBottom:0}}>
                      <div className="button white-background primary-color">{'All About Kat'}</div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </ScrollFadeIn>
        {/*
          <div className="max-width-container">
            {BlogPosts && BlogPosts.slice(0,5).map((data) =>{
              return(
                <BlogPostThumb
                  title={data.title}
                  date={data.date}
                  description={data.description}
                  slug={data.slug}
                />
              )
            })}
          </div>
        */}

        <ScrollFadeIn>
          <Flodeskform />
        </ScrollFadeIn>
        <Footer />
      </div>
    )
  }
}

export default withController(Home);



// WEBPACK FOOTER //
// ./src/pages/home/index.js